__turbopack_context__.v({
  "container": "GraphiQLPage-module__sa3drq__container",
  "graphiqlContainer": "GraphiQLPage-module__sa3drq__graphiqlContainer",
  "graphiqlWrapper": "GraphiQLPage-module__sa3drq__graphiqlWrapper",
  "header": "GraphiQLPage-module__sa3drq__header",
  "subtitle": "GraphiQLPage-module__sa3drq__subtitle",
  "title": "GraphiQLPage-module__sa3drq__title",
});
